<template>
  <v-card :elevation="$root.ele" class="mt-5">
    <v-data-table
      :headers="headers"
      class="templates-table"
      :items="list"
      :footer-props="{
        'items-per-page-options': [10, 20, 50, -1]
      }"
      :items-per-page="50"
    >
      <template v-slot:item.action="{ item }">
        <v-btn icon @click="$router.push(`/users/${item.id}`)">
          <v-icon>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:item.type="{ item }">
        {{ type(item) }}
      </template>
      <template v-slot:item.updated_by="{ item }">
        {{ updated(item) }}
      </template>
      <template v-slot:item.name="{ item }">
        <div class="text-capitalize">
          {{ item.name }}
        </div>
      </template>
    </v-data-table>
    <v-divider></v-divider>
  </v-card>
</template>

<script>
import types from "../../assets/js/types";
export default {
  data() {
    return {
      lastDoc: null,
      types: types,
      id: ""
    };
  },
  computed: {
    headers() {
      let headers = [
        { text: "NAME", value: "name" },
        { text: "EMAIL", value: "email" },
        { text: "PHONE", value: "phone" },
        { text: "UPDATED ON", value: "updated" },
        { text: "UPDATED BY", value: "updated_by" },
        { text: "ACTION", value: "action" }
      ];
      let list = [];
      for (let item of headers) {
        let { text, value } = item;
        let doc = {
          text,
          value,
          class: "text-capitalize",
          align: "start",
          sortable: true,
          divider: true
        };
        if (value === "action") doc.divider = false;
        list.push(doc);
      }
      return list;
    },
    list() {
      return this.$store.getters.users;
    }
  },
  methods: {
    updated({ updated_by }) {
      let name = updated_by;
      this.list.forEach(item => {
        let { email, first_name, last_name } = item;
        if (email === updated_by) name = `${first_name} ${last_name}`;
      });
      return name;
    },
    type({ type }) {
      let name = "";
      this.types.forEach(item => {
        if (item.value === type) name = item.name;
      });
      return name;
    }
  }
};
</script>

<style lang="scss"></style>
